var _rect, _g, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _rect5, _rect6, _rect7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFundCardBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 381,
    height: 227,
    viewBox: "0 0 381 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3719_70652",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 381,
    height: 227
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 381,
    height: 227,
    rx: 8,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3719_70652)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    clipPath: "url(#clip0_3719_70652)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 57.7071,
    y: -14.3809,
    width: 114.427,
    height: 114.427,
    rx: 8.5,
    transform: "rotate(-45 57.7071 -14.3809)",
    stroke: "#DBDBDB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 173.707,
    y: 56.8086,
    width: 35.5002,
    height: 35.5002,
    rx: 8.5,
    transform: "rotate(-45 173.707 56.8086)",
    stroke: "#EAEAEA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -35.2078,
    y: 28,
    width: 294.982,
    height: 151.027,
    rx: 20,
    transform: "rotate(45 -35.2078 28)",
    fill: "#F4FAFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-75.7554 70.7344H86.863C91.2813 70.7344 94.863 74.3161 94.863 78.7344V110.271C94.863 114.69 91.2813 118.271 86.863 118.271H-75.7554V70.7344Z",
    fill: "#88A8D2",
    fillOpacity: 0.19
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-43 85L108 85C113.523 85 118 89.4772 118 95V190C118 195.523 113.523 200 108 200H-43L-43 85Z",
    fill: "url(#paint0_linear_3719_70652)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-42.5 85.5L108 85.5C113.247 85.5 117.5 89.7533 117.5 95V190C117.5 195.247 113.247 199.5 108 199.5H-42.5L-42.5 85.5Z",
    stroke: "#B2B9C0",
    strokeOpacity: 0.42
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip1_3719_70652)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4733 137.606C93.7529 139.092 95.6073 139.92 97.5378 139.86L99.2784 144.5H76.4302L92.4733 137.606Z",
    stroke: "#DADADA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2175 137.72C93.4789 139.046 95.2267 139.8 97.0567 139.807M97.5429 138.099C95.8401 138.254 94.1744 137.537 93.1173 136.193M68.9566 143.498L74.1966 143.498L74.1967 143.498L78.0837 143.502H78.0838L98.4663 143.502L98.4667 143.502L100.283 143.498L100.283 143.498L100.296 143.498C100.68 143.498 100.99 143.809 100.99 144.192V152.339V152.561L101.196 152.479L105.115 150.915L105.254 150.86L105.199 150.72L97.7042 131.901L97.6487 131.762L97.5094 131.817L68.9011 143.208L68.9566 143.498ZM101.085 154.013L100.99 154.051V154.152V166.139C100.99 166.522 100.68 166.833 100.296 166.833H64.8441C64.4608 166.833 64.15 166.522 64.15 166.139V144.193C64.1527 143.94 64.2945 143.709 64.5191 143.592L64.55 143.576L64.5706 143.548C64.6413 143.452 64.736 143.377 64.8452 143.329L97.779 130.215L97.7791 130.216L97.7826 130.214C98.1381 130.074 98.5402 130.248 98.6815 130.603L98.6815 130.603L106.8 150.989L106.8 150.989C106.942 151.345 106.769 151.749 106.413 151.891L101.085 154.013ZM99.4523 165.444H99.6023V165.294V145.036V144.886H99.4523H65.6882H65.5382V145.036V165.294V165.444H65.6882H99.4523Z",
    fill: "#DADADA",
    stroke: "#FAFDFF",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6906 162.144L74.6641 162.136L74.6371 162.143C74.6113 162.149 74.5851 162.154 74.559 162.155C74.3238 162.154 74.1109 161.988 74.0407 161.737C73.6606 160.372 72.6575 159.301 71.3711 158.895C71.1159 158.811 70.9509 158.535 70.9969 158.242L71.0001 158.222L70.9947 158.201C70.9881 158.176 70.9832 158.151 70.98 158.125V152.633C70.9832 152.605 70.9882 152.577 70.9951 152.55L70.9999 152.531L70.997 152.511C70.9534 152.221 71.1179 151.947 71.3711 151.864C72.658 151.458 73.6612 150.386 74.0406 149.02C74.1211 148.741 74.3782 148.575 74.6371 148.619L74.6605 148.623L74.6832 148.616C74.7072 148.609 74.7318 148.603 74.7566 148.6H90.2233C90.2466 148.603 90.2697 148.608 90.2925 148.615L90.3152 148.622L90.3385 148.618C90.5989 148.571 90.8587 148.737 90.9393 149.018C91.3175 150.385 92.3205 151.458 93.6077 151.864C93.8611 151.947 94.0256 152.22 93.9818 152.511L93.9786 152.532L93.9842 152.552C93.9914 152.579 93.9967 152.606 94 152.633V158.125C93.9966 158.153 93.9914 158.181 93.9845 158.208L93.9794 158.228L93.9824 158.248C94.026 158.538 93.8615 158.812 93.6082 158.895C92.321 159.301 91.3177 160.374 90.9386 161.74L90.9383 161.74L90.9368 161.748L90.9367 161.749C90.8695 162.043 90.5961 162.213 90.3338 162.145L90.3067 162.138L90.28 162.146C90.2611 162.152 90.242 162.156 90.2227 162.159H74.7571C74.7347 162.156 74.7125 162.151 74.6906 162.144ZM90.9367 161.749C90.9366 161.749 90.9366 161.749 90.9367 161.749L90.9367 161.749ZM75.0119 149.776H74.9427L74.9183 149.841C74.4072 151.198 73.3994 152.272 72.1306 152.815L72.07 152.841V152.907V157.852V157.918L72.1306 157.944C73.399 158.488 74.4066 159.561 74.9183 160.918L74.9427 160.983H75.0119H89.9681H90.0373L90.0617 160.918C90.5734 159.561 91.581 158.488 92.8494 157.944L92.91 157.918V157.852V152.907V152.841L92.8494 152.815C91.5804 152.272 90.5724 151.198 90.0611 149.841L90.0367 149.776H89.9675H75.0119Z",
    fill: "#D9D9D9",
    stroke: "#FAFBFD",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3719_70652",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 144,
    width: 35,
    height: 22
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4333 144.678H99.8334V165.7H65.4333V144.678Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3719_70652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.4448 142.771C74.3849 148.176 69.953 152.505 64.5461 152.439L64.6295 144.908C64.6433 143.662 65.6672 142.664 66.9164 142.679L74.4448 142.771Z",
    fill: "#EAF1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5228 158.261C69.9743 158.327 74.3451 162.781 74.2849 168.208L66.6895 168.115C65.4327 168.1 64.4251 167.071 64.4389 165.817L64.5228 158.261Z",
    fill: "#EAF1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6432 168.1C90.7067 162.37 95.4046 157.781 101.136 157.851L101.048 165.834C101.033 167.155 99.9478 168.213 98.6235 168.197L90.6432 168.1Z",
    fill: "#EAF1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.503 152.741C95.1796 152.676 90.9117 148.327 90.9705 143.028L98.3874 143.118C99.6147 143.133 100.599 144.138 100.585 145.362L100.503 152.741Z",
    fill: "#EAF1FB"
  })))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 277.121,
    y: 247.33,
    width: 83.7326,
    height: 112.427,
    rx: 7.5,
    transform: "rotate(-45 277.121 247.33)",
    stroke: "#F0F5FC",
    strokeWidth: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 106.707,
    y: 185.809,
    width: 35.5002,
    height: 35.5002,
    rx: 8.5,
    transform: "rotate(-45 106.707 185.809)",
    stroke: "#EAEAEA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 173.707,
    y: 56.8086,
    width: 35.5002,
    height: 35.5002,
    rx: 8.5,
    transform: "rotate(-45 173.707 56.8086)",
    stroke: "#EAEAEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3719_70652",
    x1: 37,
    y1: 100,
    x2: 37.5,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3719_70652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 381,
    height: 227,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3719_70652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    fill: "white",
    transform: "translate(64 127)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundCardBackground);
export default __webpack_public_path__ + "static/media/fund-card-background.3259fca856fddad67986384b79c7b7a4.svg";
export { ForwardRef as ReactComponent };